module.exports = __webpack_public_path__ + "img/smis-hub-logo.68817376.png";